import GiftCardOption from "../Shared/GiftCardOption";

const giftCardOptions = [25, 50, 70, 100, 200, 500];

function GiftCardOptionsList() {
  function displayOptionsList() {
    return giftCardOptions.map((option) => (
      <GiftCardOption
        key={option}
        amount={option}
      />
    ));
  }

  return (
    <section className="px-3">
      <div className="gift-card-options-list-container">
        {displayOptionsList()}
      </div>
    </section>
  );
}

export default GiftCardOptionsList;
